var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"ma-16",attrs:{"elevation":"0","color":"tertiary"}},[_c('settings-controls')],1)}
var staticRenderFns = []

export { render, staticRenderFns }